import {
  loginFailure,
  logoutSuccess,
} from '~/GlobalRedux/Features/auth/authSlice';
import instance from './axios';

const axiosInterceptor = (store: any) => {
  instance.interceptors.response.use(
    response => response,
    error => {
      if (200 === error.response.status) {
        store.dispatch(loginFailure());
      }
      if (403 === error.response.status) {
        store.dispatch(logoutSuccess());
      }
    },
  );
};

export default axiosInterceptor;
